import { useState, useEffect } from 'react'
import './card-closed.scss'
// components
import Button from 'components/atoms/button/button'
import Image from 'components/atoms/Image/image'
import Card from 'components/atoms/card/card'
// icons
import { CloseIcon } from 'components/atoms/icons'

const CardClosed = props => {
	const { url, buttonTitle, title, description, onClick, onClose = () => {} } = props

	// states
	const [stateCard, setStateCard] = useState({
		showCard: true,
		hide: false
	})

	// actions
	const timeHideCard = () =>
		setTimeout(
			() =>
				setStateCard({
					...stateCard,
					showCard: false
				}),
			300
		)

	const closeCard = () => {
		timeHideCard()
		onClose && onClose()
		setStateCard({
			...stateCard,
			hide: true
		})
	}

	useEffect(() => {
		return clearTimeout(timeHideCard)
	}, [])

	if (!stateCard.showCard) return null

	return (
		<Card classes={`m-card_closed ${stateCard.hide ? 'hide' : ''}`}>
			<button onClick={() => closeCard()} className='m-card_closed__close'>
				<CloseIcon />
			</button>
			{url && <Image src={url} width='40' height='40' alt={title} classes='m-card_closed__img' />}
			<div className='m-card_closed__body'>
				{title && <p className='m-card_closed__title'>{title}</p>}
				{description && <p className='m-card_closed__description'>{description}</p>}
				<Button uppercase title={buttonTitle} classes='small fit ml mr mt1' onClick={onClick} />
			</div>
		</Card>
	)
}

export default CardClosed
